import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BuyerOffersService {
  constructor(private http: HttpService) {}

  makeOffer(body: {
    amount: number;
    notes: string;
    auction_item_id: number;
    parent_offer_id: any;
  }): Observable<any> {
    return this.http.post(
      `${environment.url}/buyer/auction-item/makeOffer`,
      body
    );
  }
  cancelOffer(body: { offer_id: number }): Observable<any> {
    return this.http.post(
      `${environment.url}/buyer/auction-item/cancelOffer`,
      body
    );
  }
  resendToCounterOffer(body: {
    offer_id: number;
    accepted: number;
  }): Observable<any> {
    return this.http.post(
      `${environment.url}/buyer/auction-item/respondToCounterOffer`,
      body
    );
  }
  myOffers(params: any): Observable<any> {
    return this.http.getWithParams(
      `${environment.url}/buyer/auction-item/myOffers`,
      params
    );
  }
  offersHistory(params: any): Observable<any> {
    return this.http.getWithParams(
      `${environment.url}/buyer/auction-item/myOffersHistory`,
      params
    );
  }
}
